import {useEffect, useRef} from "react";
import * as couponService from "../service/couponService";
import {getShopCouponListApi} from "../service/couponService";

// 리뷰 리스트 조회
export function useCouponList(setters, data, shopId) {
  useEffect(() => {
    const couponList = async () => {
      if(data) {
        const couponData = await couponService.getCouponList(data);

        setters.setCouponList?.(couponData);
      }
    }
    couponList();
  }, [shopId])
}

// 상점 쿠폰 리스트 조회
export const useShopCouponList = async (setters, data) => {
  const previousDataRef = useRef();

  useEffect(() => {
    const response = async () => {
      if(data) {
        const getData = await getShopCouponListApi(data);

        setters.setList?.(getData.data);
        setters.setTotalPage?.(getData.totalPage);
        setters.setTotalCount?.(getData.totalCount);
      }
    }
    if (JSON.stringify(previousDataRef.current) !== JSON.stringify(data)) {
      response();
      previousDataRef.current = data;
    }
  }, [data, setters]);
}